/**
 * Hooks
 */
export const TOGGLE_AFTER = new CustomEvent("toggleAfter"),
	TOGGLE_BEFORE = new CustomEvent("toggleBefore");



// WEBPACK FOOTER //
// ./node_modules/easy-toggle-state/src/constants/events.js